module.exports = "https://trybtryb-legacy.web.app/img/vimeo.96b37898.svg";